module.exports = __webpack_public_path__ + "img/logo-top-chunrk.3ae55961.png";